import { Directive, Input, OnChanges } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  type ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[minNumericValue]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinNumericValueDirective,
      multi: true,
    },
  ],
})
export class MinNumericValueDirective implements Validator, OnChanges {
  @Input() minNumericValue: number;

  private onValidatorChange: () => void;

  validate(control: AbstractControl): ValidationErrors | null {
    return Validators.min(this.minNumericValue)(control);
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  ngOnChanges(): void {
    this.onValidatorChange?.();
  }
}
